export { useTinRegistration } from './hooks';
export { tinReducer } from './reducer';
